"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardRequirementsComponent = void 0;
const vue_1 = require("vue");
exports.CardRequirementsComponent = vue_1.default.component('CardRequirements', {
    props: {
        requirements: {
            type: Object,
            required: true,
        },
    },
    methods: {
        getClasses: function () {
            const classes = ['card-requirements'];
            if (this.requirements.hasMax()) {
                classes.push('card-requirements-max');
            }
            return classes.join(' ');
        },
    },
    template: `
        <div v-if="requirements.isHE3ProductionQuotas()">
            <div :class="getClasses()" style="display:inline-block;"> 
                <span class="party">Any Kelvinists</span>
            </div>
            <div :class="getClasses()" style="display:inline-block; margin-top:5px;"> 
                <span>Any 1 Mine tile</span>
            </div>
        </div>

        <div v-else-if="requirements.hasParty()" :class="getClasses()">
            <span class="party">{{ requirements.getRequirementsText() }}</span>
        </div>
        <div v-else-if="requirements.hasPlantsRemoved()" :class="getClasses()"> 
            <div class="card-special card-minus"></div>
            <div class="card-resource card-resource-plant red-outline"></div>
        </div>
        <div v-else :class="getClasses()">{{ requirements.getRequirementsText() }}</div>
    `,
});
//# sourceMappingURL=CardRequirementsComponent.js.map